import React, { useState, useRef, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import { User, LogOut } from "lucide-react";
import { AuthContext } from "../../Context/ContextFunctions";

const UserDropdown = () => {
  const { authDetails } = useContext(AuthContext);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  console.log("authDetails", authDetails);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <>
      {/* Logo, company name, and user section */}
      <div className="relative hidden lg:flex items-center">
        {/* Logo and Company name */}
        <div
          className="flex flex-col items-end cursor-pointer"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        >
          <div className="flex items-center">
            <img
              className="h-11 w-11 rounded-full"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTxW1LXs2gfdZamygA3s5dbJLPridVx30eZQ&s"
              alt="Logo of Surya Group"
            />
            <div className="ml-3 flex flex-col">
              <span
                className="text-xl font-light text-white"
                style={{
                  fontSize: "0.99rem",
                  fontFamily: "Poppins, sans-serif",
                }}
              >
                Surya Group
              </span>
              <span className="text-sm text-gray-200 mt-1">
                {`Welcome, ${authDetails.employeeName}`}
              </span>
            </div>
          </div>
        </div>

        {/* Dropdown Menu */}
        {isDropdownOpen && (
          <div className="absolute top-full right-0 mt-1 w-40 bg-white rounded-md shadow-lg py-1 z-50  rounded-lg shadow w-44">
            <div class="px-4 py-3 text-sm text-gray-900 dark:text-dark">
              <div>{authDetails.employeeName}</div>
            </div>
            <hr style={{ fontWeight: "bolder" }} />
            <Link
              to="/profile"
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-400"
              onClick={() => setIsDropdownOpen(false)}
            >
              <User size={16} className="mr-2" />
              Profile
            </Link>
            <Link
              to="/login"
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-blue-400"
              onClick={() => setIsDropdownOpen(false)}
            >
              <LogOut size={16} className="mr-2" />
              Logout
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default UserDropdown;
